import React, { createContext, useContext, useState, useEffect, useMemo } from 'react'
import { usePaletteTheme } from '../../../context/paletteTheme'
import { useReportPanelContext } from './useReportPanelContext'

const ReportGraph = createContext()


export const ReportGraphProvider = ({data, children }) => {
    const [ activeLegendTickers, setActiveLegendsTickers ] = useState([])
    const { colors } = usePaletteTheme()
    const { avg } = useReportPanelContext()

    const industryAvg = useMemo(() => {
        const IndustryData = avg?.find(({dataset, column}) => data.dataset === dataset && data.column === column)
        return IndustryData ? {
            ...IndustryData, 
            color: colors.textPrimary, 
            linePathProps: {strokeDasharray:"1,5"},
            linearGradient: {fromOpacity: 0}
        } : {}
    },[avg, data, colors.textPrimary])
    
    const allGraphs = useMemo(() => [
        {
            ...data, 
            color: colors.data2, 
            linearGradient: {fromOpacity: 0}
        }, industryAvg].filter(value => Object.keys(value).length !== 0)
    ,[industryAvg, data, colors.data2])
    
    useEffect(() => {setActiveLegendsTickers(allGraphs.filter(graph => (graph.ticker !== 'Industry Avg' && graph.ticker)).map(graph => graph.ticker));return () => {}} ,[allGraphs])

    const selectedGraphs = useMemo(() => allGraphs.filter(graph => activeLegendTickers.includes(graph.ticker)), [activeLegendTickers, allGraphs])

    const handleLegendClick = (item) => setActiveLegendsTickers(state => !state.includes(item) ? [...state, item] : state.filter(selectedItem => selectedItem !== item))

    return (
        <ReportGraph.Provider value={{
            selectedGraphs,
            handleLegendClick,
            graphs: allGraphs,
            activeLegendTickers,
        }}>
            { children}
        </ReportGraph.Provider>
    )

}

export function useReportGraphContext() {
    return useContext(ReportGraph)
}